import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {
    AdvanceSaleGroup,
    AdvanceSaleGroupProduct,
    AdvanceSaleSelectedCampaignProducts
} from "../../model/club-gigot/action-points/action-points-configuration.model";

@Injectable({ providedIn: "root" })
export class AdvanceSaleService {

    SelectedAdvanceSale = new BehaviorSubject<AdvanceSaleGroup | null>(null);
    SelectedAdvanceSaleCampaign = new BehaviorSubject<AdvanceSaleSelectedCampaignProducts | null>(null);
    loading = new BehaviorSubject<boolean>(false);

    constructor() {
    }

    public setSelectedAdvanceSale(advanceSale: any) {
        this.SelectedAdvanceSale.next(advanceSale);
    }

    public getSelectedAdvanceSaleObs() {
        return this.SelectedAdvanceSale.asObservable();
    }

    public clearSelectedAdvanceSale() {
        this.SelectedAdvanceSale.next(null);
        this.clearSelectedAdvanceSaleCampaign();
    }

    public getSelectedAdvanceSale() {
        return this.SelectedAdvanceSale.getValue();
    }

    public setSelectedAdvanceSaleCampaign(advanceSaleSelectedCampaignProducts: AdvanceSaleSelectedCampaignProducts) {
        this.SelectedAdvanceSaleCampaign.next(advanceSaleSelectedCampaignProducts);
    }

    public getSelectedAdvanceSaleCampaignObs() {
        return this.SelectedAdvanceSaleCampaign.asObservable();
    }

    public clearSelectedAdvanceSaleCampaign() {
        this.SelectedAdvanceSaleCampaign.next(null);
    }

    public getSelectedAdvanceSaleCampaign() {
        return this.SelectedAdvanceSaleCampaign.getValue();
    }

    public startLoading(){
        this.loading.next(true);
    }

    public stopLoading(){
        this.loading.next(false);
    }

    public getLoadingObs(){
        return this.loading.asObservable();
    }
}
